type GetAccessTokenSilently = (options?: Record<string, unknown>) => Promise<string>;

const base: GetAccessTokenSilently = async () => {
  throw new Error("getAccessTokenSilently has not been configured");
};

let getAccessTokenSilently: GetAccessTokenSilently = base;

export const security = {
  getAccessTokenSilently: (): GetAccessTokenSilently => getAccessTokenSilently,
  setAccessTokenSilently: (func: GetAccessTokenSilently) => (getAccessTokenSilently = func),
};
